var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "edit-user-modal",
      staticClass: "mt-0",
      attrs: {
        id: "edit-user-modal",
        size: "lg",
        title: _vm.modalTitle,
        centered: "",
        "hide-footer": true
      },
      on: { hidden: _vm.resetForm },
      model: {
        value: _vm.showEditUserModal,
        callback: function($$v) {
          _vm.showEditUserModal = $$v
        },
        expression: "showEditUserModal"
      }
    },
    [
      [
        _c(
          "div",
          { attrs: { id: "datos-usuario" } },
          [
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("h5", [_vm._v("Datos Usuario")]),
              _vm._v(" "),
              _vm.editedUser.isLockPending || _vm.editedUser.isUnlockPending
                ? _c("h6", { staticClass: "status pending-status" }, [
                    _vm._v("\n          " + _vm._s(_vm.editedUser.status))
                  ])
                : _vm.editedUser.is_active
                ? _c("h6", { staticClass: "status active-status" }, [
                    _vm._v(" " + _vm._s(_vm.editedUser.status))
                  ])
                : _c("h6", { staticClass: "status locked-status" }, [
                    _vm._v(" " + _vm._s(_vm.editedUser.status))
                  ])
            ]),
            _vm._v(" "),
            _c(
              "b-form",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "font-size-1rem",
                            attrs: { label: "Nick *" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate.immediate",
                                  value: "required|max:255",
                                  expression: "'required|max:255'",
                                  modifiers: { immediate: true }
                                }
                              ],
                              attrs: {
                                disabled: !_vm.isEditable,
                                name: "Nick",
                                state: _vm.errors.has("Nick") ? false : null
                              },
                              model: {
                                value: _vm.editedUser.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.editedUser, "username", $$v)
                                },
                                expression: "editedUser.username"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Nick")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "font-size-1rem",
                            attrs: { label: "Email *" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate.immediate",
                                  value: "required|max:255|email",
                                  expression: "'required|max:255|email'",
                                  modifiers: { immediate: true }
                                }
                              ],
                              attrs: {
                                disabled:
                                  !_vm.isEditable &&
                                  !_vm.editedUser.isUnlockPending,
                                name: "Email",
                                state: _vm.errors.has("Email") ? false : null
                              },
                              model: {
                                value: _vm.editedUser.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.editedUser, "email", $$v)
                                },
                                expression: "editedUser.email"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Email")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "font-size-1rem",
                            attrs: { label: "Nombre *" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate.immediate",
                                  value: "required|max:255",
                                  expression: "'required|max:255'",
                                  modifiers: { immediate: true }
                                }
                              ],
                              attrs: {
                                disabled: !_vm.isEditable,
                                name: "Nombre",
                                state: _vm.errors.has("Nombre") ? false : null
                              },
                              model: {
                                value: _vm.editedUser.first_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.editedUser, "first_name", $$v)
                                },
                                expression: "editedUser.first_name"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Nombre")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "font-size-1rem",
                            attrs: { label: "Apellidos *" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate.immediate",
                                  value: "required|max:255",
                                  expression: "'required|max:255'",
                                  modifiers: { immediate: true }
                                }
                              ],
                              attrs: {
                                disabled: !_vm.isEditable,
                                name: "Apellidos",
                                state: _vm.errors.has("Apellidos")
                                  ? false
                                  : null
                              },
                              model: {
                                value: _vm.editedUser.last_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.editedUser, "last_name", $$v)
                                },
                                expression: "editedUser.last_name"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Apellidos")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "font-size-1rem",
                            attrs: { label: "Metadatos" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate.immediate",
                                  value: "max:255",
                                  expression: "'max:255'",
                                  modifiers: { immediate: true }
                                }
                              ],
                              attrs: {
                                disabled: !_vm.isEditable,
                                name: "Metadatos"
                              },
                              model: {
                                value: _vm.editedUser.metadatos,
                                callback: function($$v) {
                                  _vm.$set(_vm.editedUser, "metadatos", $$v)
                                },
                                expression: "editedUser.metadatos"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Metadatos")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "permissions-selection" } }, [
          _c("div", [_c("h5", [_vm._v("Selección Permisos")])]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-row",
                  attrs: { id: "permissions-selection-type" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-row align-items-center",
                      attrs: { id: "permissions-input-manual" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.profileSelectionType,
                            expression: "profileSelectionType"
                          }
                        ],
                        attrs: {
                          disabled: !_vm.isEditable,
                          type: "radio",
                          id: "manual",
                          value: "manual"
                        },
                        domProps: {
                          checked: _vm._q(_vm.profileSelectionType, "manual")
                        },
                        on: {
                          change: function($event) {
                            _vm.profileSelectionType = "manual"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "mb-0", attrs: { for: "manual" } },
                        [_vm._v("Manualmente")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-row align-items-center",
                      attrs: { id: "permissions-input-user" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.profileSelectionType,
                            expression: "profileSelectionType"
                          }
                        ],
                        attrs: {
                          disabled: !_vm.isEditable,
                          type: "radio",
                          id: "byUser",
                          value: "byUser"
                        },
                        domProps: {
                          checked: _vm._q(_vm.profileSelectionType, "byUser")
                        },
                        on: {
                          change: function($event) {
                            _vm.profileSelectionType = "byUser"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "mb-0", attrs: { for: "byUser" } },
                        [_vm._v("Por usuario")]
                      ),
                      _vm._v(" "),
                      _c("multiselect", {
                        staticClass: "multiselect-user",
                        attrs: {
                          id: "multiselect-user",
                          options: _vm.usersList,
                          disabled:
                            !_vm.isEditable ||
                            _vm.profileSelectionType === "manual",
                          label: "username",
                          "track-by": "username",
                          placeholder: "",
                          "custom-label": _vm.getCustomLabelUser,
                          size: "sm"
                        },
                        on: {
                          select: function($event) {
                            _vm.updateUserSelected($event)
                          }
                        },
                        model: {
                          value: _vm.userSelected,
                          callback: function($$v) {
                            _vm.userSelected = $$v
                          },
                          expression: "userSelected"
                        }
                      }),
                      _vm._v(" "),
                      _vm.downloadingUserPermissions
                        ? _c("b-spinner", {
                            attrs: {
                              variant: "primary",
                              label: "Downloading Permissions"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-list-group",
                { staticClass: "scroll-permissions w-100" },
                [
                  _c(
                    "b-list-group-item",
                    {
                      staticClass: "d-flex align-items-center position-sticky",
                      attrs: { id: "permissions-header" }
                    },
                    [
                      _c("span", { staticClass: "flex-30" }, [
                        _vm._v("Grupos")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-70 text-center" },
                        _vm._l(_vm.permissionsList, function(permission, i) {
                          return _c(
                            "span",
                            { key: i, staticClass: "text-capitalize flex-1" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(permission.permiso.toLowerCase()) +
                                  "\n              "
                              )
                            ]
                          )
                        })
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.rolesList, function(role, i) {
                    return _c(
                      "b-list-group-item",
                      { key: i, staticClass: "d-flex row-padding" },
                      [
                        _c("span", { staticClass: "text-capitalize flex-30" }, [
                          _vm._v(_vm._s(role.rol.toLowerCase()))
                        ]),
                        _vm._v(" "),
                        _c("b-form-group", { staticClass: "mb-0 flex-70" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-wrap" },
                            _vm._l(_vm.permissionsList, function(permission) {
                              return _c("b-form-checkbox", {
                                key: permission.letra,
                                staticClass: "custom-checkbox",
                                attrs: {
                                  disabled:
                                    !_vm.isEditable ||
                                    _vm.profileSelectionType === "byUser",
                                  inline: ""
                                },
                                model: {
                                  value:
                                    _vm.editedUser.permisos[role.rol][
                                      permission.letra
                                    ],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editedUser.permisos[role.rol],
                                      permission.letra,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editedUser.permisos[role.rol][permission.letra]"
                                }
                              })
                            })
                          )
                        ])
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ])
      ],
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { staticClass: "text-left" },
              [
                _vm.editedUser.is_active
                  ? _c(
                      "b-button",
                      {
                        attrs: {
                          disabled: _vm.editedUser.isLockPending,
                          variant: "primary"
                        },
                        on: { click: _vm.updateLockPendingStatus }
                      },
                      [_vm._v("\n          Bloquear\n        ")]
                    )
                  : _c(
                      "b-button",
                      {
                        attrs: {
                          disabled: _vm.editedUser.isUnlockPending,
                          variant: "primary"
                        },
                        on: { click: _vm.updateUnlockPendingStatus }
                      },
                      [_vm._v("\n          Desbloquear\n        ")]
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c("b-col", { staticClass: "text-align-right" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "d-block mr-16",
                      model: {
                        value: _vm.editedUser.enviar_notificacion,
                        callback: function($$v) {
                          _vm.$set(_vm.editedUser, "enviar_notificacion", $$v)
                        },
                        expression: "editedUser.enviar_notificacion"
                      }
                    },
                    [_vm._v("\n            Enviar notificación\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        disabled:
                          !_vm.editedUser.is_active &&
                          !_vm.editedUser.isUnlockPending,
                        variant: "primary"
                      },
                      on: { click: _vm.saveUser }
                    },
                    [_vm._v("\n            Guardar\n          ")]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/SystemManagement/users-management/edit-user/EditUser.vue?vue&type=template&id=26978645&scoped=true&
// module id = null
// module chunks = 